<template>
    <div class="panel">
        <div class="fake-button">&nbsp;</div>
        <transition name="slide" appear>
            <MultiselectButtonGroup v-bind:buttons="buttons" />
        </transition>
    </div>
</template>

<script>
    import MultiselectButtonGroup from '@/components/MultiselectButtonGroup.vue'
    import response from '@/stores/response.js'

    export default {
        name: 'Challenges_panel',
        data: function () {
            return {
                response: response,
                buttons: [
                    [
                        { text: 'Work' }
                    ],
                    [
                        { text: 'Family' }
                    ],
                    [
                        { text: 'Social' }
                    ],
                    [
                        { text: 'Sex / Intimacy' }
                    ],
                    [    
                        { text: 'Fatigue / Lethargy' }
                    ],
                    [ 
                        { text: 'Pain' }
                    ],
                    [
                        { text: 'Rest / Sleeping' }
                    ],
                    [
                        { text: 'Depression' }
                    ],
                    [
                        { text: 'Other' },
                    ],
                    [
                        { text: 'None', noOption: true }
                    ]
                ]
            };
        },
        components: {
            MultiselectButtonGroup
        }
    };
</script>

<style lang="stylus">
.panel
    text-align: center
    display: flex
    flex-direction: column
    align-items: center
    background-color: #6D8E93
    .fake-button
        background-color: #72A2A8
        width: 220px
        height: 25px
    .slide-enter, .slide-leave-to
        transform: translateY(-100%)
    .slide-leave-active, .slide-enter-active
        transition: 1s
    .button-row
        display: flex
        justify-content: center
        flex: 1
        .button-group-item
            button
                height: 40px
                width: 220px
                background-color: #72A2A8
                color: white
                border: none
                border-top: 1px solid white
                cursor: pointer
                font-size: 1em
                font-weight: bold
                &.active
                    background-color: #C4DF9B
                &#None
                    height: 65px
</style>